import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "seatbeltFilled"
const SeatbeltFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 12.75C12.902 12.75 13.713 12.862 14.44 13.063L5.004 22.5H3.75V21.75H4.5 3.75V21.716L3.752 21.634Q3.754 21.531 3.766 21.347C3.782 21.103 3.814 20.76 3.876 20.35 4 19.53 4.249 18.427 4.755 17.314S6.035 15.054 7.22 14.185C8.413 13.31 9.978 12.75 12 12.75M19.235 11.36C19.82 11.946 19.82 12.895 19.235 13.48L10.215 22.5H7.126L18.75 10.875zM18.64 16.196C18.875 16.565 19.076 16.941 19.245 17.314 19.751 18.428 20 19.531 20.124 20.35 20.186 20.759 20.218 21.104 20.234 21.347Q20.245 21.531 20.248 21.634L20.25 21.716V21.749L19.5 21.75H20.25V22.5H12.337z" />
          <path
            fillRule="evenodd"
            d="M12.375 1.5C15.067 1.5 17.25 3.683 17.25 6.375S15.067 11.25 12.375 11.25 7.5 9.067 7.5 6.375 9.683 1.5 12.375 1.5M10.875 7.5C10.875 7.898 11.033 8.28 11.315 8.56 11.595 8.843 11.977 9 12.375 9S13.155 8.842 13.435 8.56C13.718 8.28 13.875 7.899 13.875 7.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SeatbeltFilledIcon
